import { get } from 'lodash';
import { useIntl } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import { ProjectBudgetDocument } from 'graphql/generated/graphql';

const useProjectBudgetQuery = (projectId: string) => {
  const { locale } = useIntl();
  const { data, loading } = useQuery(ProjectBudgetDocument, { variables: { projectId, locale } });
  const project = get(data, 'project', null);
  const myBudget = get(data, 'myBudget', null);

  return { project, myBudget, loading };
};

export default useProjectBudgetQuery;
